"use client"

import { createContext, useContext, useState, type ReactNode } from "react"

interface SearchJobLinkContextType {
  linkedJobId: string | null
  linkedJobTitle: string | null
  setLinkedJob: (jobId: string, jobTitle: string) => void
  clearLinkedJob: () => void
  isLinked: boolean
}

const SearchJobLinkContext = createContext<SearchJobLinkContextType | undefined>(undefined)

export function SearchJobLinkProvider({ children }: { children: ReactNode }) {
  const [linkedJobId, setLinkedJobId] = useState<string | null>(null)
  const [linkedJobTitle, setLinkedJobTitle] = useState<string | null>(null)

  const setLinkedJob = (jobId: string, jobTitle: string) => {
    setLinkedJobId(jobId)
    setLinkedJobTitle(jobTitle)
    console.log("[v0] Search linked to job:", { jobId, jobTitle })
  }

  const clearLinkedJob = () => {
    setLinkedJobId(null)
    setLinkedJobTitle(null)
    console.log("[v0] Search job link cleared")
  }

  const isLinked = linkedJobId !== null

  return (
    <SearchJobLinkContext.Provider
      value={{
        linkedJobId,
        linkedJobTitle,
        setLinkedJob,
        clearLinkedJob,
        isLinked,
      }}
    >
      {children}
    </SearchJobLinkContext.Provider>
  )
}

export function useSearchJobLink() {
  const context = useContext(SearchJobLinkContext)
  if (context === undefined) {
    throw new Error("useSearchJobLink must be used within a SearchJobLinkProvider")
  }
  return context
}
